export default __webpack_public_path__ + "media/images/ui-bg_glass_95_fef1ec_1x400-1f9b8e8b95c7792b0825a208730f2dae.png";